import { Badge, Popover } from "antd";
import { useTranslation } from "react-i18next";
import { MdFilterList } from "react-icons/md";
import Button from "shared/components/Button";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import {
  DOCUMENT_TEMPLATE_STATES,
  GENERATED_DOCUMENTS_TYPES,
} from "utils/constants";
import { activeFilterCount, EMPTY_FILTERS } from "./document-filters";

const FiltersPopover = ({ filters, products, onChange }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const FILTERS = t("LIST.FILTERS", { returnObjects: true });
  const STATES = t("LIST.STATES", { returnObjects: true });
  const TYPES = t("LIST.TYPES", { returnObjects: true });
  const count = activeFilterCount(filters);

  const typeOptions = GENERATED_DOCUMENTS_TYPES.map((value) => ({
    value,
    label: TYPES[value] || value,
  }));
  const stateOptions = Object.values(DOCUMENT_TEMPLATE_STATES).map((value) => ({
    value,
    label: STATES[value],
  }));

  const setFilter = (key) => (value) =>
    onChange({ ...filters, [key]: value ?? null });

  const fields = [
    { key: "type", label: FILTERS.TYPE, options: typeOptions },
    { key: "state", label: FILTERS.STATE, options: stateOptions },
    { key: "product", label: FILTERS.PRODUCT, options: products },
  ];

  const content = (
    <div className="dynamic-documents__filters">
      {fields.map(({ key, label, options }) => (
        <Select
          key={key}
          label={label}
          placeholder={FILTERS.ALL}
          options={options}
          value={filters[key] ?? undefined}
          onChange={setFilter(key)}
          allowClear
          showSearch
        />
      ))}
      <Button
        type="gray--link"
        disabled={count === 0}
        onClick={() => onChange(EMPTY_FILTERS)}
      >
        {FILTERS.CLEAR}
      </Button>
    </div>
  );

  return (
    <Popover trigger="click" placement="bottomRight" content={content}>
      <div className="dynamic-documents__filters-trigger">
        <Button type="primary--outlined">
          <MdFilterList size={18} />
          <span>{FILTERS.BUTTON}</span>
          {count > 0 && (
            <Badge
              count={count}
              size="small"
              className="dynamic-documents__filters-count"
            />
          )}
        </Button>
      </div>
    </Popover>
  );
};

export default FiltersPopover;
